<template>
  <div>
    <video-player :options="videoOptions" />
  </div>
</template>

<script>
import VideoPlayer from "@/components/video-player/VideoPlayer.vue";

export default {
  name: "VideoExample",
  components: {
    "video-player": VideoPlayer
  },
  data() {
    return {
      videoOptions: {
        autoplay: true,
        controls: true,
        muted: true,
        fill: true,
        loop: true,
        poster: "https://f001.backblazeb2.com/file/ballstar/poster.png",
        sources: [
          {
            src:
              "https://f001.backblazeb2.com/file/ballstar/BallstarLandingPage.mp4",
            type: "video/mp4"
          }
        ]
      }
    };
  }
};
</script>
